module.exports = __webpack_public_path__ + "17f5f6cf34393c96799f894838861799.svg";